var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-card",
    {
      staticClass: "image-container",
      staticStyle: { "background-color": "#FAFBFB" }
    },
    [
      _c("template", { attrs: { slot: "body" }, slot: "body" }, [
        _c("section", { staticClass: "text-content" }, [
          _c(
            "div",
            { staticClass: "text-content__icon" },
            [
              _c("sc-icon", {
                attrs: { icon: "far fa-info-circle", size: "is-small" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-content__message" }, [
            _c("p", [
              _vm._v(
                "\n          Para identificar a linha do cabeçalho de sua fatura é simples,\n          o cabeçalho é onde está o título das informações dos pedidos da cobrança.\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n          No exemplo abaixo, o cabeçalho "),
              _c("strong", [_vm._v("está na linha 2 da planilha.")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "image-content" }, [
          _c("img", {
            attrs: {
              src: "/static/images/audit/helper-1.5x.png",
              alt: "Exemplo de fatura"
            }
          })
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f3a9227", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3a9227","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateImageHelper.vue
// module id = null
// module chunks = 